import React, { useEffect, useState } from "react";
import classes from "./CreatePaper.module.css";
import Graybg from "../../UI/Graybg";
import SecBTN from "../../UI/SecBTN";
import BtnWrapper from "../../UI/BtnWrapper";
import Card from "../../UI/Card/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Breadcrumb } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../UI/loader/loader";
import userService from "../../app/services/user.service";
import SmallLoader from "../../UI/SmallLoader/SmallLoader";
import { toast } from "react-toastify";
import Toast from "../../UI/Toast/Toast";
import { isEmpty } from "../../utils/custom_funtions";
import { uid } from 'react-uid';

const Pending = (props) => {
  return (
    <Card className={props.status == 2 ? "border border-warning" : "" }>
      <Row>
        <Col lg={10} md={8} sm={12}>
          <h5>
            {props.done ? <i className="bx bx-check bx-sm"></i> : ""}{" "}
            {`${props.paper_topic}  (${props.pid}) - (${props.ques_assigned}) `}
          </h5>
          <Row>
            <Col lg={8} md={6} sm={12}>
              <p><b>Class</b> : {props.class}</p>
              <p><b>Subject</b> : {props.subject}</p>
              <p><b>Target</b> : {props.target}</p>
              <p><b>Format</b> : {props.format}</p>
              <p><b>Questions Assigned by</b> : {props.ques_assigned_by}</p>
              <p><b>Questions Assigned</b> : {props.ques_assigned_no}</p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p><b>Assigned on</b> : {new Date(props.assigned_on).toLocaleDateString("sv-SE")}</p> 
              <p><b>Exam Date</b> : {props.exam_date}</p>
              <p><b>Date Of Submission</b> : {props.date_submission}</p>
              <p><b>Date Of Finalization</b> : {props.date_finalization}</p>
              {props.batch && <p><b>Batch</b> : {props.batch}</p>}
            </Col>
          </Row>
        </Col>
        <Col lg={2} md={4} sm={12} className="text-center text-sm-center text-md-end text-lg-end">
          {/* <Link to={ props.paperPending ? "/createPaper/paperMatrix" : `/createPaper/paperMatrix/${props.uid}/${props.sid}/${props.pid}`}> */}
          <Link
            to={"/createPaper/paperMatrix"}
            state={{ uid: props.uid, sid: props.sid, pid: props.pid,batch:props.batch ?? "" }}
          >
            <SecBTN className={classes["cp-btn"]}>
              {props.done ? "View" : "Create"}
            </SecBTN>
          </Link>
          <br />
          <br />
          <Link
            to={"/createPaper/createDummy"}
            state={{ uid: props.uid, sid: props.sid, pid: props.pid }}
          >
            <SecBTN className={classes["cp-btn"]}>
              Create Dummy
            </SecBTN>
          </Link>
        </Col>
      </Row>
    </Card>
  );
};
const Completed = (props) => {
  return (
    <Card style={{ border: "1.5px solid #269100" }}>
      <Row>
        <Col lg={10} md={8} sm={12}>
          <div className="d-flex justify-content-start">
            <h5 style={{ color: "#269100" }}>
              <i className="bx bx-check bx-sm"></i>
            </h5>
            <div className="w-100">
              <h5>{`${props.paper_topic}  (${props.pid}) - (${props.ques_assigned}) `}</h5>
              <Row>
                <Col lg={8} md={6} sm={12}>
                <p><b>Class</b> : {props.class}</p>
                <p><b>Subject</b> : {props.subject}</p>
              <p><b>Target</b> : {props.target}</p>
              <p><b>Format</b> : {props.format}</p>
              <p><b>Questions Assigned by</b> : {props.ques_assigned_by}</p>
              <p><b>Questions Assigned</b> : {props.ques_assigned_no}</p>
                </Col>
                <Col lg={4} md={6} sm={12}>
                <p><b>Assigned on</b> : {new Date(props.assigned_on).toLocaleDateString("sv-SE")}</p> 
              <p><b>Exam Date</b> : {props.exam_date}</p>
              <p><b>Date Of Submission</b> : {props.date_submission}</p>
              <p><b>Date Of Finalization</b> : {props.date_finalization}</p>
              {props.batch && <p><b>Batch</b> : {props.batch}</p>}
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col lg={2} md={4} sm={12} className="text-end">
          <Link
            to={`/createPaper/CompletedQues/`}
            state={{ uid: props.uid, sid: props.sid, pid: props.pid, batch:props.batch ?? "" }}
          >
            <SecBTN className={classes["cp-btn"]}>
              {props.done ? "View" : "Create"}
            </SecBTN>
          </Link>
        </Col>
      </Row>
    </Card>
  );
};
const CreatePaper = () => {
  const {state} = useLocation();
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const btnType = ["Pending", "Completed"];
  const [isPending, setISPending] = useState(isEmpty(state) ? btnType[0] : state.btnType);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [loadMore, setloadMore] = useState(true);
  const [pendingData, setPendingData] = useState([]);
  const [pendingPages, setpendingPages] = useState(1);
  const [completedData, setCompletedData] = useState([]);
  const [completedPages, setCompletedPages] = useState(1);

  const pendingPaperFn = () => {
    // userService
    //   .getPendingPaper(pendingPages)
    //   .then((data) => {
    //     if (data.data.data.length < 50) {
    //       setloadMore(false);
    //     }
    //     setLoading(false);
    //     // setPendingData(data.data.data);
    //   })
    //   .catch((error) => {
    //     setLoading(false);
    //     console.log("error", error);
    //     toast.error(error.message);
    //   });
      userService
      .getPendingPaperList(pendingPages)
      .then((data) => {
        if (data.data.data.length < 50) {
          setloadMore(false);
        }
        setLoading(false);
        console.log("getPendingPaperList",Object.values(data.data.data))
        setPendingData(Object.values(data.data.data));
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
        toast.error(error.message);
      });
  };
  const pendingPaperUidFn = () => {
    userService
      .getPendingPaperByUid(user_id, pendingPages)
      .then((data) => {
        if (data.data.data.length < 50) {
          setloadMore(false);
        }
        setLoading(false);
        setPendingData(data.data.data);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error", error);
        toast.error(error.message);
      });
  };
  const CompletedPaperFn = () => {
    // userService
    //   .getCompletedPaper(completedPages)
    //   .then((data) => {
    //     if (data.data.data.length < 50) {
    //       setloadMore(false);
    //     }
    //     setLoading(false);
    //     setCompletedData(data.data.data);
    //   })
    //   .then(() => setLoading(false))
    //   .catch((error) => {
    //     setLoading(false);
    //     console.log("error1", error.message);
    //     toast.error(error.message);
    //   });
      userService
      .getCompletedPaperList(completedPages)
      .then((data) => {
        if (data.data.data.length < 50) {
          setloadMore(false);
        }
        setLoading(false);
        // console.log("getCompletedPaperList",Object.values(data.data.data));
        setCompletedData(Object.values(data.data.data));
        console.log(Object.values(data.data.data));
      })
      .then(() => setLoading(false))
      .catch((error) => {
        setLoading(false);
        console.log("error1", error.message);
        toast.error(error.message);
      });
  };
  const CompletedPaperUidFn = () => {
    userService
      .getCompletedPaperByUid(user_id, completedPages)
      .then((data) => {
        if (data.data.data.length < 50) {
          setloadMore(false);
        }
        setLoading(false);
        setCompletedData(data.data.data);
      })
      .then(() => setLoading(false))
      .catch((error) => {
        setLoading(false);
        console.log("error1", error.message);
        toast.error(error.message);
      });
  };

  useEffect(() => {
    if (isPending === btnType[0]) {
      setLoading(true);
      pendingPaperFn();
      // if (user_id == 1) {
      //   pendingPaperFn();
      // } else {
      //   pendingPaperUidFn();
      // }
    } else {
      setLoading(true);
      CompletedPaperFn();
      // if (user_id == 1) {
      //   CompletedPaperFn();
      // } else {
      //   CompletedPaperUidFn();
      // }
    }
  }, [isPending]);
  const loadMoreHandler1 = () => {
    setBtnLoading(true);
    setpendingPages((prev) => prev + 1);
    if (user_id == 1 || 4 || 6) {
      userService
        .getPendingPaperList(pendingPages + 1)
        .then((data) => {
          console.log(data.data.data)
          if (data.data.data.length < 50) {
            setloadMore(false);
          }
          setPendingData((prev) => {
            return [...prev, ...Object.values(data.data.data)];
          });
        })
        .then(() => setBtnLoading(false))
        .catch((error) => {
          setBtnLoading(false);
          toast.error(error.message);
        });
    } else {
      userService
        .getPendingPaperByUid(user_id, pendingPages + 1)
        .then((data) => {
          if (data.data.data.length < 50) {
            setloadMore(false);
          }
          setPendingData((prev) => {
            return [...prev, ...data.data.data];
          });
        })
        .then(() => setBtnLoading(false))
        .catch((error) => {
          setBtnLoading(false);
          toast.error(error.message);
        });
    }
  };
  const loadMoreHandler = () => {
    setBtnLoading(true);
    setCompletedPages((prev) => prev + 1);
    if (user_id == 1 || 4 || 6) {
      userService
        .getCompletedPaperList(completedPages + 1)
        .then((data) => {
          if (data.data.data.length < 50) {
            setloadMore(false);
          }
          setCompletedData((prev) => {
            return [...prev, ...Object.values(data.data.data)];
          });
        })
        .then(() => {
          setBtnLoading(false);
        })
        .catch((error) => {
          setBtnLoading(false);
          toast.error(error.message);
        });
    } else {
      userService
        .getCompletedPaperByUid(user_id, completedPages + 1)
        .then((data) => {
          if (data.data.data.length < 50) {
            setloadMore(false);
          }
          setCompletedData((prev) => {
            return [...prev, ...data.data.data];
          });
        })
        .then(() => {
          setBtnLoading(false);
        })
        .catch((error) => {
          setBtnLoading(false);
          toast.error(error.message);
        });
    }
  };
  
  return (
    <>
      <div className={`${classes.createpaper} section `}>
        {loading && <Loader />}
        <Toast />
        <h4>Create Paper</h4>
        <Breadcrumb>
          <Breadcrumb.Item active>Create Paper</Breadcrumb.Item>
          <Breadcrumb.Item active>
            {isPending === btnType[0] ? btnType[0] : btnType[1]}
          </Breadcrumb.Item>
        </Breadcrumb>
        <Graybg>
          <BtnWrapper className={classes["btn-sec"]}>
            {btnType.map((type) => {
              return (
                <SecBTN
                  className={isPending === type && "active"}
                  key={uid(type)}
                  onClick={() => {
                    setISPending(type);
                    setpendingPages(1);
                    setCompletedPages(1);
                  }}
                  type="button"
                >
                  {type}
                </SecBTN>
              );
            })}
          </BtnWrapper>
          {isPending === btnType[0] ? (
            (isEmpty(pendingData) && !loading) ? (
              <p className="text-center">No data available.</p>
            ) : (
              pendingData.map((data, i) => (
                <>
                <Pending
                  key={uid(data, i)}
                  status={data.status}
                  paper_topic={data.paper_name}
                  format={data.format}
                  exam_date={data.to_be_held_on}
                  date_submission={data.to_be_completed_by}
                  ques_assigned={data.faculty_name}
                  uid={data.user_id}
                  sid={data.sub_id}
                  pid={data.paper_id}
                  target={data.target}
                  ques_assigned_by={data.assignee}
                  assigned_on={data.assigned_on}
                  date_finalization={data.to_be_final_by}
                  class={data.class}
                  subject={data.subj}
                  batch={data.batch_name}
                  ques_assigned_no={data.num_questions}
                  // batch_name={data.batch_name}
                />
                {/* <p>{JSON.stringify(data.TblPaperDetail.TblPaperBatchesRels[0])}</p> */}
                </>
              ))
            )
          ) : (isEmpty(completedData) && !loading) ? (
            <p className="text-center">No data available.</p>
          ) : (
            completedData.map((data, i) => (
              <Completed
                key={uid(data, i)}
                done={true}
                paper_topic={data.paper_name}
                  format={data.format}
                  exam_date={data.to_be_held_on}
                  date_submission={data.to_be_completed_by}
                  ques_assigned={data.faculty_name}
                  uid={data.user_id}
                  sid={data.sub_id}
                  pid={data.paper_id}
                  target={data.target}
                  ques_assigned_by={data.assignee}
                  assigned_on={data.assigned_on}
                  date_finalization={data.to_be_final_by}
                  class={data.class}
                  subject={data.subj}
                  batch={data.batch_name}
                  ques_assigned_no={data.num_questions}
              />
            ))
          )}
        </Graybg>
        {/* {isPending === btnType[0] ? ( */}
        {(loadMore && ((isPending === btnType[0] && !isEmpty(pendingData)) || (isPending === btnType[1] && !isEmpty(completedData)))) && (
          <div className="text-center my-4">
            <SecBTN
              className={`${classes.btn} sec-btn1`}
              onClick={
                isPending === btnType[0] ? loadMoreHandler1 : loadMoreHandler
              }
            >
              Load more
              {btnLoading && <SmallLoader />}
            </SecBTN>
          </div>
        )}
        {/* 
        <div className="text-center my-4">
          <SecBTN
            className={`${classes.btn} sec-btn1`}
            onClick={loadMoreHandler}
          >
            Load more
            {btnLoading && <SmallLoader />}
          </SecBTN>
        </div>
      )} */}
      </div>
    </>
  );
};

export default CreatePaper;
